import { MouseEvent, useEffect, useRef, useState } from 'react';

import { useModal } from 'components/elements/modal';
import SharePlpCard from 'components/elements/shareCard';
import LoginModule from 'components/modules/login';
import { useHasAuth } from 'lib/DataStore';
import { PdpService } from 'lib/apis/services/PdpSingle';
import { PlpActionService } from 'lib/apis/services/plpCardAction';
import useOwnRouter from 'lib/hooks/useOwnRouter';
import { useOwnTranslate } from 'lib/hooks/useOwnTranslate';
import { singleDynamicModle } from '../constant/single';
import { useGetAllFavorite } from '../../../../lib/apis/services/plpCardAction/service';

export const useContactInfo = () => {
  const { router } = useOwnRouter();
  const identifier = router.query.id as string;
  const { t } = useOwnTranslate('plp.card');
  const afterAuthState = useRef<'save' | 'req' | null>(null);
  const [favStatus, setFavStatus] = useState(false);
  const [modalOpened, setModalOpened] = useState(false);
  const { data } = PdpService.usePdpSingleQuery(identifier);

  const { data: AllFavorite, refetch: refetchFavorites } = useGetAllFavorite();
  useEffect(() => {
    if(AllFavorite?.data?.data.length) {
      const hasFav = AllFavorite.data.data.filter((item) => item === +identifier);
      if(hasFav.length){
        setFavStatus(true);
        console.log("im here",favStatus);
      }
    }
  },[AllFavorite]);
  const hasAuth = useHasAuth();
  const isBuy = data!.data.listing.listingType;

  const dynamicModel = singleDynamicModle[isBuy ==="BUY" ? 'buy' : 'rent'];

  const pdpContactInfo = data?.data.listing.agency;

  const makeFav = PlpActionService.useSaveListingMutate();

  const sendSaveListing = async () => {
    if (hasAuth) {
      await makeFav.mutateAsync({
        glistingIdentifier: identifier,
        typeFav: !favStatus,
        status: !favStatus,
      });
      setFavStatus((state) => !state);
      await refetchFavorites();
    }
  };

  const authModal = useModal({
    id: `pdp-auth-${identifier}`,
    async onChange(_open) {
      if (!_open && modalOpened) {
        if (afterAuthState.current === 'req') {
          setModalOpened(false);
        } else if (afterAuthState.current === 'save') {
          sendSaveListing();
        }
      } else {
        setModalOpened(true);
      }
    },
    content: (
      <div className="p-6">
        <LoginModule isModal modalId={`pdp-auth-${identifier}`} />
      </div>
    ),
  });

  const saveListing = async (e?: MouseEvent<HTMLButtonElement>) => {
    e?.stopPropagation();
    e?.preventDefault();
    if (!hasAuth) {
      afterAuthState.current = 'save';
      authModal.openModal();
    } else {
      sendSaveListing();
    }
  };

  const shareModal = useModal({
    id: `pdp-share`,
    closeable: false,
    content: ({ closeModal }) =>
      data ? (
        <div className="p-6">
          <SharePlpCard
            isBuy={isBuy === "BUY"}
            data={data.data.listing}
            dynamicModel={dynamicModel}
            closeModal={closeModal}
          />
        </div>
      ) : null,
  });

  return {
    pdpContactInfo,
    data,
    dynamicModel,
    hasAuth,
    afterAuthState,
    authModal,
    favStatus,
    makeFav,
    saveListing,
    shareModal,
    t,
    identifier,
  };
};
